export default [
  {
    header: '—— การเงิน ——',
  },
  {
    title: 'แจ้งชำระเงิน',
    route: 'finance-transfer',
    icon: 'CreditCardIcon',
  },
  {
    title: 'แจ้งร้านจีนคืนเงิน',
    route: 'finance-refund',
    icon: 'CreditCardIcon',
  },
  {
    title: 'วิธีแจ้งชำระเงินจีน',
    route: 'inform-payment',
    icon: 'BookOpenIcon',
  },
  {
    title: 'รายการ Balance',
    route: 'finance-balance',
    icon: 'BriefcaseIcon',
  },
  {
    title: 'ถอนเงิน',
    route: 'finance-withdraw',
    icon: 'HomeIcon',
  },
]
